// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"d82ff86b","312":"e3b97e18","318":"0ad27b85","347":"c6002cf6","356":"0ad27b85","359":"c5b9e27d","452":"d82ff86b","481":"d82ff86b","572":"2606151d"}[chunkId] + ".chunk.css";
};